//采购商导航菜单
export default [
    {label:'酒店询价',iconClass:'icon-dingdan',powerArr:[222],path:{name:'OrderPost',query:{type:'住宿订单',order:true}}},
    {label:'待处理', iconClass:'icon-shenpizhong', powerArr:[79,222],path:{name:'OrderHandle',query:{page:1,orderStatus:'0',orderType:3}},num:'wait_handle'},
    {label:'订单管理',iconClass:'icon-dingdan1',powerArr:[221,261,365,433,431,138,107,546],path:{name:'OrderLists',query:{page:1,orderStatus:'all',orderType:3}},num:'order'},
    {label:'导游管理',iconClass:'icon-renshiguanli',powerArr:[471],path:{name:'GuidesManage', query: {storeType:4,page:1}}},
    {label:'业务管理',iconClass:'icon-yewu',powerArr:[222],path:{name:'BusinessList'},num:'order'},
    {label:'财务管理',iconClass:'icon-caiwuguanli',powerArr:[152,268,367,231,554,555],path:{name:'FinancialList'},num:'treasurer_count'},
    {label:'企业信息',
    iconClass:'icon-Information',
        // children:[
        //     // {label:'门店资料',powerArr:[152,268,367,231,554,555],path:{name:'StoreBasicInfo'}},
        //     // {label:'认证信息',powerArr:[152,268,367,231,554,555],path:{name:'StoreCertification'}},
        //     // {label:'银行卡管理',powerArr:[152,268,367,231,554,555],path:{name:'BankcardManage'}},
        //     // {label:'导游管理',powerArr:[243],path:{name:'IncomeDetail'}},
        // ],
        path:{name:'StoreCertification'}
    },
    // {label:'关联管理',
    //     iconClass:'icon-zhuce',
    //     children:[
    //         {label:'关联企业',powerArr:[332,175,288,387,581],path:{name:'SalesList'}},
    //         {label:'关联列表',powerArr:[337,170,293,392,582],path:{name:'PersonnelList'}},
    //     ],
    // },
    {label:'积分明细',iconClass:'icon-jifen',powerArr:[],path:{name:'GradeManage'}},
    {label:'消息中心',iconClass:'icon-xiaoxi',powerArr:[],path:{name:'MsgLists',query:{msg_type:'2'}}},
    {label:'账号设置',iconClass:'icon-shezhi',powerArr:[],path:{name:'AccountSet'}}
]